import { LayoutModule } from "@angular/cdk/layout";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { BackButtonDeprecatedComponent } from "@hermes/aphrodite/back-button-deprecated";
import { MessageBlockComponent } from "@hermes/aphrodite/message-block";
import {
    svgArrowRight,
    SvgIconComponent,
    SvgRegistryService,
} from "@hermes/aphrodite/svg";
import { LivechatDirectiveModule } from "@hermes/fragments/livechat-directive";
import { SeoLinksModule } from "@hermes/fragments/seo-links";
import { ShopModule } from "@hermes/fragments/shop";
import { ShopLocatorModule } from "@hermes/fragments/shop-locator";
import { ShopLocatorServiceModule } from "@hermes/shop-utils";
import { FlipperStateModule } from "@hermes/states/flipper";
import { ShopLocationsStateModule } from "@hermes/states/shop-locations";
import { ShopLocatorStateModule } from "@hermes/states/shop-locator";

import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";

import { ShopLocatorAnalyticsService } from "./analytics/services/shop-locator-analytics.service";
import { ShopLocatorNavigationComponent } from "./components/shop-locator-navigation/shop-locator-navigation.component";
import { ShopLocatorNavigationItemComponent } from "./components/shop-locator-navigation-item/shop-locator-navigation-item.component";
import { ShopLocatorPageComponent } from "./components/shop-locator-page/shop-locator-page.component";
import { ShopLocatorShopsListComponent } from "./components/shop-locator-shops-list/shop-locator-shops-list.component";
import { ShopLocatorPageHeadService } from "./services/shop-locator-page-head.service";
import { ShopLocatorPageRoutingModule } from "./shop-locator-page-routing.module";

@NgModule({
    imports: [
        ShopLocatorPageRoutingModule,
        FlipperStateModule,
        CommonModule,
        MessageBlockComponent,
        LivechatDirectiveModule,
        ShopModule,
        ShopLocatorModule,
        ShopLocatorStateModule,
        LayoutModule,
        BackButtonDeprecatedComponent,
        SeoLinksModule,
        SvgIconComponent,
        ShopLocationsStateModule,
        ShopLocatorServiceModule,
        SrOnlyNoSnippetDirective,
    ],
    declarations: [
        ShopLocatorPageComponent,
        ShopLocatorShopsListComponent,
        ShopLocatorNavigationComponent,
        ShopLocatorNavigationItemComponent,
    ],
    providers: [ShopLocatorAnalyticsService, ShopLocatorPageHeadService],
})
export class ShopLocatorPageModule {
    constructor(svgRegistryService: SvgRegistryService) {
        svgRegistryService.registerSvgs([svgArrowRight]);
    }
}
